module.exports = __webpack_public_path__ + "img/third-world-bg.b7dc032d.png";